var diac1 = "\u00e1\u00e4\u010d\u010f\u00e9\u011b\u00ed\u013a\u013e\u0148\u00f3\u00f4 \u00f6\u0155\u0161\u0165\u00fa\u016f \u00fc\u00fd\u0159\u017e\u00c1\u00c4\u010c\u010e\u00c9\u011a\u00cd\u0139\u013d\u0147\u00d3\u00d4 \u00d6\u0154\u0160\u0164\u00da\u016e \u00dc\u00dd\u0158\u017d";
var diac0 = "aacdeeillnoo orstuu uyrzAACDEEILLNOO ORSTUU UYRZ";
var regexp1 = new Array(/\n/g, / /g, /\./g, /-/g, /(#\|)/g, /(ch)/g, /a/g, /b/g, /c/g, /d/g, /e/g, /f/g, /g/g, /h/g, /i/g, /j/g, /k/g, /l/g, /m/g, /n/g, /o/g, /p/g, /q/g, /r/g, /s/g, /t/g, /u/g, /v/g, /w/g, /x/g, /y/g, /z/g, /1/g, /2/g, /3/g, /4/g, /5/g, /6/g, /7/g, /8/g, /9/g, /0/g, /;/g, /\?/g, /=/g, /:/g, /@/g, /,/g, /\//g, /!/g, /\(/g, /\)/g, /"/g, /_/g);
var replace1 = new Array("|", "", "#", "-....-", ".-.-.-", "----", ".-", "-...", "-.-.", "-..", ".", "..-.", "--.", "....", "..", ".---", "-.-", ".-..", "--", "-.", "---", ".--.", "--.-", ".-.", "...", "-", "..-", "...-", ".--", "-..-", "-.--", "--..", ".----", "..---", "...--", "....-", ".....", "-....", "--...", "---..", "----.", "-----", "-.-.-.", "..--..", "-...-", "---...", ".--.-.", "--..--", "-..-.", "--...-", "-.--.", "-.--.-", ".-..-.", "..--.-");
var morseo = new Array;
morseo[".-"] = "a";
morseo["-..."] = "b";
morseo["-.-."] = "c";
morseo["-.."] = "d";
morseo["."] = "e";
morseo["..-."] = "f";
morseo["--."] = "g";
morseo["...."] = "h";
morseo["----"] = "ch";
morseo[".."] = "i";
morseo[".---"] = "j";
morseo["-.-"] = "k";
morseo[".-.."] = "l";
morseo["--"] = "m";
morseo["-."] = "n";
morseo["---"] = "o";
morseo[".--."] = "p";
morseo["--.-"] = "q";
morseo[".-."] = "r";
morseo["..."] = "s";
morseo["-"] = "t";
morseo["..-"] = "u";
morseo["...-"] = "v";
morseo[".--"] = "w";
morseo["-..-"] = "x";
morseo["-.--"] = "y";
morseo["--.."] = "z";
morseo[".----"] = "1";
morseo["..---"] = "2";
morseo["...--"] = "3";
morseo["....-"] = "4";
morseo["....."] = "5";
morseo["-...."] = "6";
morseo["--..."] = "7";
morseo["---.."] = "8";
morseo["----."] = "9";
morseo["-----"] = "0";
morseo[".-.-.-"] = ".";
morseo["-.-.-."] = ";";
morseo["..--.."] = "?";
morseo["-...-"] = "=";
morseo["---..."] = ":";
morseo[".--.-."] = "@";
morseo["-....-"] = "-";
morseo["--..--"] = ",";
morseo["--...-"] = "!";
morseo["-..-."] = "/";
morseo["-.--."] = "(";
morseo["-.--.-"] = ")";
morseo[".-..-."] = '"';
morseo["..--.-"] = "_";

function diacritic(text)
{
	var return_text = "";
	var length = text.length;
	for (var i = 0; i < length; i++)
	{
		var index = diac1.indexOf(text.charAt(i));
		if (index != -1) return_text += diac0.charAt(index);
		else return_text += text.charAt(i)
	}
	return return_text
}

function textToMorse(text, morse)
{
	var txt = diacritic(text.value);
	txt = txt.toLowerCase();
	var regexp_length = regexp1.length;

	for (var i = 0; i < regexp_length; i++)
		txt = txt.replace(regexp1[i], replace1[i] + "|");

	txt = txt.replace(/[^\.\-|]+/g, "");
	morse.value = txt;
}

function morseToText(morse, text)
{
	var txt = morse.value.replace(/[^\u00b7\.\-_|\/ ]+/g, "");
	txt = txt.replace(/\u00b7/g, ".");
	txt = txt.replace(/_/g, "-");
	txt = txt.replace(/\//g, "|");
	txt = txt.replace(/ /g, "|");
	while (txt.charAt(txt.length - 1) == "|" && txt.charAt(txt.length - 2) == "|")
		txt = txt.substring(0, txt.length - 1);

	if (txt.charAt(txt.length - 1) != "|")
		txt += "|";

	txt = txt.replace(/(\|\|\|)+/g, "\n");
	txt = txt.replace(/(\|\|)+/g, " ");

	var txt_length = txt.length;
	var word = "";
	var output = "";

	for (var i = 0; i < txt_length; i++)
	{
		var charAt = txt.charAt(i);

		if (charAt == ".")
			word += ".";
		else if (charAt == "-")
			word += "-";
		else if (charAt == "|" || (charAt == "\n" || charAt == " "))
		{
			if (morseo[word])
				output += morseo[word] + (charAt != "|" ? charAt : "");

			word = "";
		}
	}

	text.value = output;
}
